import api from './api';
import {
  ParkingFloorListResponse,
  ParkingAddonListResponse,
  ParkingTypeListResponse,
  ParkingFloor,
  ParkingAddon,
  ParkingType
} from '../types/parking';

// Parking Floors
export const parkingFloorService = {
  getAll: async (workspaceId: string, params?: any): Promise<ParkingFloorListResponse> => {
    const response = await api.get(`/workspaces/${workspaceId}/parking-floors`, { params });
    return response.data;
  },

  getById: async (workspaceId: string, id: string): Promise<{ parkingFloor: ParkingFloor }> => {
    const response = await api.get(`/workspaces/${workspaceId}/parking-floors/${id}`);
    return response.data;
  },

  create: async (workspaceId: string, data: any): Promise<{ parkingFloor: ParkingFloor }> => {
    const response = await api.post(`/workspaces/${workspaceId}/parking-floors`, data);
    return response.data;
  },

  update: async (workspaceId: string, id: string, data: any): Promise<{ parkingFloor: ParkingFloor }> => {
    const response = await api.put(`/workspaces/${workspaceId}/parking-floors/${id}`, data);
    return response.data;
  },

  delete: async (workspaceId: string, id: string): Promise<void> => {
    await api.delete(`/workspaces/${workspaceId}/parking-floors/${id}`);
  },

  getSpacesByFloor: async (workspaceId: string, floorId: string, params?: any): Promise<{ parkingSpaces: any[] }> => {
    const response = await api.get(`/workspaces/${workspaceId}/parking-spaces/by-floor/${floorId}`, { params });
    return response.data;
  },

  updateSpace: async (workspaceId: string, spaceId: string, data: any): Promise<{ parkingSpace: any }> => {
    const response = await api.put(`/workspaces/${workspaceId}/parking-spaces/${spaceId}`, data);
    return response.data;
  },

  uploadLayout: async (workspaceId: string, floorId: string, layoutData: any): Promise<{ parkingFloor: any }> => {
    const response = await api.post(`/workspaces/${workspaceId}/parking-floors/${floorId}/layout`, layoutData);
    return response.data;
  },

  createSpace: async (workspaceId: string, data: any): Promise<{ parkingSpace: any }> => {
    const response = await api.post(`/workspaces/${workspaceId}/parking-spaces`, data);
    return response.data;
  },

  deleteSpace: async (workspaceId: string, spaceId: string): Promise<void> => {
    await api.delete(`/workspaces/${workspaceId}/parking-spaces/${spaceId}`);
  },

  bulkUpdateSpaces: async (workspaceId: string, updates: Array<{ id: string; spaceObject: any }>): Promise<{ updated: number }> => {
    const response = await api.put(`/workspaces/${workspaceId}/parking-spaces/bulk-update`, { updates });
    return response.data;
  },

  bulkCreateSpaces: async (workspaceId: string, spaces: any[]): Promise<{ parkingSpaces: any[]; count: number; message: string }> => {
    const response = await api.post(`/workspaces/${workspaceId}/parking-spaces/bulk-create`, { spaces });
    return response.data;
  }
};

// Parking Add-ons
export const parkingAddonService = {
  getAll: async (workspaceId: string, params?: any): Promise<ParkingAddonListResponse> => {
    const response = await api.get(`/workspaces/${workspaceId}/parking-addons`, { params });
    return response.data;
  },

  getById: async (workspaceId: string, id: string): Promise<{ parkingAddon: ParkingAddon }> => {
    const response = await api.get(`/workspaces/${workspaceId}/parking-addons/${id}`);
    return response.data;
  },

  create: async (workspaceId: string, data: any): Promise<{ parkingAddon: ParkingAddon }> => {
    const response = await api.post(`/workspaces/${workspaceId}/parking-addons`, data);
    return response.data;
  },

  update: async (workspaceId: string, id: string, data: any): Promise<{ parkingAddon: ParkingAddon }> => {
    const response = await api.put(`/workspaces/${workspaceId}/parking-addons/${id}`, data);
    return response.data;
  },

  delete: async (workspaceId: string, id: string): Promise<void> => {
    await api.delete(`/workspaces/${workspaceId}/parking-addons/${id}`);
  }
};

// Parking Types
export const parkingTypeService = {
  getAll: async (workspaceId: string, params?: any): Promise<ParkingTypeListResponse> => {
    const response = await api.get(`/workspaces/${workspaceId}/parking-types`, { params });
    return response.data;
  },

  getById: async (workspaceId: string, id: string): Promise<{ parkingType: ParkingType }> => {
    const response = await api.get(`/workspaces/${workspaceId}/parking-types/${id}`);
    return response.data;
  },

  create: async (workspaceId: string, data: any): Promise<{ parkingType: ParkingType }> => {
    const response = await api.post(`/workspaces/${workspaceId}/parking-types`, data);
    return response.data;
  },

  update: async (workspaceId: string, id: string, data: any): Promise<{ parkingType: ParkingType }> => {
    const response = await api.put(`/workspaces/${workspaceId}/parking-types/${id}`, data);
    return response.data;
  },

  delete: async (workspaceId: string, id: string): Promise<void> => {
    await api.delete(`/workspaces/${workspaceId}/parking-types/${id}`);
  }
};

// Parking Spaces
export const parkingSpaceService = {
  bulkUpdate: async (workspaceId: string, updates: any[]): Promise<{ updated: number }> => {
    const response = await api.put(`/workspaces/${workspaceId}/parking-spaces/bulk-update`, { updates });
    return response.data;
  }
};
